

export const getHours = () => {
    let A = [
        '11:00 - 12:00',
        '08:00 - 09:00',
        '09:00 - 10:00',
        '10:00 - 11:00',
        '11:00 - 12:00',
        '12:00 - 01:00',
        '01:00 - 02:00',
        '02:00 - 03:00',
        '03:00 - 04:00',
        '04:00 - 05:00',
        // 'simón al rato',
    ]
    const am = "am";
    const pm = "pm";
    let B = [
        `8 ${am} - 9 ${am}`,
        `9 ${am} - 10 ${am}`,
        `10 ${am} - 11 ${am}`,
        `11 ${am} - 12 ${am}`,
        `12 ${pm} - 1 ${pm}`,
        `1 ${pm} - 2 ${pm}`,
        `2 ${pm} - 3 ${pm}`,
        `3 ${pm} - 4 ${pm}`,
        `4 ${pm} - 5 ${pm}`,
        `5 ${pm} - 6 ${pm}`,
        `6 ${pm} - 7 ${pm}`,
        `7 ${pm} - 8 ${pm}`,
    ]
    return (B)
}